export default __webpack_public_path__ + "static/media/tomatoPlant_x375.aff0d31a.png";